import { createBrowserRouter, createRoutesFromElements, Route, RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import Quiz from './pages/quiz';
import { useTranslation } from 'react-i18next';
// import QuizResult from './pages/quiz-result';

const pathname = window.location.pathname;

const queryClient = new QueryClient();

const router = createBrowserRouter(
	createRoutesFromElements(
		<Route path={pathname}>
			<Route index element={<Quiz />} />,
			{/* <Route path="/result" element={<QuizResult />} /> */}
		</Route>
	)
)

function App() {
	const { t } = useTranslation()


	return (
		<>
			<QueryClientProvider client={queryClient}>
				<RouterProvider router={router} />
			</QueryClientProvider>
		</>
	);
}

export default App
